import { all } from "@redux-saga/core/effects";
import { schedulersEntriesSagas } from "modules/Scheduler/services/InitialScrapeTasks/sagas";
import { initScheduler } from "modules/Scheduler/services/initialization/sagas";
import { schedulersStatisticSagas } from "modules/Scheduler/services/InitialScrapeTasksStatistic/sagas";

export function* schedulerSaga() {
    yield all([
        initScheduler(),
        schedulersEntriesSagas(),
        schedulersStatisticSagas()
    ]);
}